<template>
  <div>
    <div
      v-if="clientPanier"
      class="dropdown"
      :class="{'is-active': isOpen}">
      <div class="dropdown-trigger">
        <div class="card header-taille"
            :class="{'noHandCursor': disabled}"
            @click="changeIsOpen"
            aria-haspopup="false"
            aria-controls="dropdown-menu2">
          <div
            class="card-header">
            <img v-if="!clientPanier.urlLogo" class="icon-client"
              src="@/assets/default-placeholder.png"/>
            <img v-if="clientPanier.urlLogo" class="img-client" :width="iconWidth"
              :height="iconHeight" :src="clientPanier.urlLogo"/>
            <p class="card-header-title">
              {{clientPanier.nomCommercial}}
              <niveau-blocage-icone
                v-if="clientPanier.blocageLevel"
                :niveau="clientPanier.blocageLevel"
                size="is-small"/>
            </p>
            <p v-if="contactPanier" class="card-header-title has-text-weight-normal">
              {{contactPanier.nom}} {{contactPanier.prenom}}
            </p>
            <a class="card-header-icon" v-if="!disabled">
              <b-icon
                :icon="isOpen ? 'menu-down' : 'menu-up'">
              </b-icon>
            </a>
          </div>
        </div>
      </div>
      <div class="dropdown-menu" id="dropdown-menu2" role="menu">
        <div class="dropdown-content card-client" v-if="!disabled && isOpen">
          <div >
            <div class="card-content" v-if="contactPanier">
              <div class="content">
                <p class="subtitle">Informations contact</p>
                <span>Téléphone : <strong>{{contactPanier.telephone}}</strong></span><br>
                <span>Email : <strong>{{contactPanier.email}}</strong></span><br>
                <div class="is-size-7 supprimerContact">
                  <a @click="contactPanier = null" class="has-text-danger">
                    Supprimer un contact
                  </a>
                </div>
                <router-link v-if="clientPanier.num"
                  :to="{ name: 'ficheclient', params: {num: clientPanier.num}}"
                  target="_blank">
                  <button class="button is-primary button-modal voirClient">
                    Voir le profil du client
                  </button>
                </router-link>
                <br>
                <button class="button is-gris button-modal" @click="supprimerClient()">
                  Supprimer le client
                </button>
              </div>
            </div>
            <div class="card-content" v-else>
              <app-ajout-contact/>
              <div class="has-text-centered">
                <button class="button is-gris button-modal has-addons-centered"
                        @click="supprimerClient()">
                  Supprimer le client
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="button is-pulled-left add-client"
            @click="isComponentAjoutClientActive = true"
            v-if="!clientPanier && !disabled">
      <b-icon icon="plus-circle" type="is-primary" class="icon-plus-circle"></b-icon>
      <div class="button-add-client">Ajouter un client</div>
    </button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesPanier from '@/store/creationOpportunite/panier-mutation-type';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import NiveauBlocageIcone from '@/components/general/NiveauBlocageIcone';
import ajoutContact from './ajoutContact';

const Panier = createNamespacedHelpers('panier');
const Modal = createNamespacedHelpers('modal');

export default {
  name: 'client',
  components: {
    appAjoutContact: ajoutContact,
    niveauBlocageIcone: NiveauBlocageIcone,
  },
  props: ['disabled'],
  data() {
    return {
      isOpen: false,
      iconWidth: 0,
      iconHeight: 0,
    };
  },
  computed: {
    ...Panier.mapGetters({
      getContactPanier: 'contactPanier',
      getClientPanier: 'clientPanier',
    }),
    ...Modal.mapGetters({
      getIsComponentAjoutClientActive: 'isComponentAjoutClientActive',
    }),
    contactPanier: {
      get() {
        return this.getContactPanier;
      },
      set(value) {
        this.setContactPanier(value);
      },
    },
    clientPanier: {
      get() {
        return this.getClientPanier;
      },
      set(value) {
        this.setClientPanier(value);
      },
    },
    isComponentAjoutClientActive: {
      get() {
        return this.getIsComponentAjoutClientActive;
      },
      set(value) {
        this.setIsComponentAjoutClient(value);
      },
    },
  },
  watch: {
    clientPanier() {
      this.initSize();
    },
  },
  methods: {
    ...Panier.mapMutations({
      setContactPanier: typesPanier.SET_CONTACT_PANIER,
      setClientPanier: typesPanier.SET_CLIENT_PANIER,
    }),
    ...Modal.mapMutations({
      setIsComponentAjoutClient: typesModal.SET_IS_COMPONENT_AJOUT_CLIENT,
    }),
    changeIsOpen() {
      this.isOpen = !this.isOpen;
    },
    supprimerClient() {
      this.contactPanier = null;
      this.clientPanier = null;
    },
    initSize() {
      if (!this.clientPanier) return '';
      if (this.clientPanier.urlLogo) {
        this.iconHeight = 40;
        this.iconWidth = this.iconHeight;
        const img = new Image();
        img.src = this.clientPanier.urlLogo;
        if (img.height > 0) {
          this.iconWidth = img.width / (img.height / this.iconHeight);
        }
        if (this.iconWidth > 65) {
          this.iconWidth = 65;
          this.iconHeight = img.height / (img.width / this.iconWidth);
        }
      }
      return '';
    },
  },
  mounted() {
    this.initSize();
  },
};
</script>

<style scoped>
  .card-client {
    position:absolute;
    z-index: 9;
    background-color: white;
    border-top: 1px solid lightgrey;
    width: 320px;
  }
  .header-taille {
    width: 320px;
  }
  .icon-client {
    max-width: 40px;
    max-height: 40px;
  }
  .img-client {
    max-height: 40px;
    max-width: 65px;
    align-self: center;
  }
  .card-header {
    height: 40px;
  }

  input, .supprimerContact, .voirClient {
    margin-bottom: 10px;
  }

  .button-add-client {
    padding-left: 10px;
  }

  span, p {
    font-size: 14px;
    color: #2C3E50;
  }

  .add-client {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/client/client.vue